import { useEffect, useState } from "react";
import { Clock } from "lucide-react";
import { useAuth, idleRemaining } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function IdleWarning() {
  const { user, idleWarn, stayConnected, logout } = useAuth();
  const [left, setLeft] = useState(idleRemaining());

  useEffect(() => {
    if (!idleWarn) { return undefined; }
    setLeft(idleRemaining());
    const t = setInterval(() => setLeft(idleRemaining()), 1000);
    return () => clearInterval(t);
  }, [idleWarn]);

  if (!user || !idleWarn) return null;
  const m = Math.floor(left / 60000);
  const s = String(Math.floor((left % 60000) / 1000)).padStart(2, "0");

  return (
    <div data-testid="idle-warning" className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-[#123B4A]/50 backdrop-blur-sm p-4">
      <div className="w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl fade-up">
        <div className="w-12 h-12 rounded-2xl bg-[#FF5A4F]/10 flex items-center justify-center mb-4">
          <Clock className="w-6 h-6 text-[#FF5A4F]" />
        </div>
        <h2 className="font-display text-2xl font-black text-[#123B4A]">Toujours là ?</h2>
        <p className="text-sm text-[#71828A] mt-2">
          Sans activité, vous serez déconnecté dans <span data-testid="idle-countdown" className="font-bold text-[#FF5A4F]">{m}:{s}</span>.
        </p>
        <Button data-testid="idle-stay-btn" onClick={stayConnected} className="flame-gradient w-full rounded-full font-bold py-6 mt-5 text-base">Rester connecté</Button>
        <button data-testid="idle-logout-btn" onClick={logout} className="w-full text-sm font-semibold text-[#71828A] mt-3 py-2">Me déconnecter</button>
      </div>
    </div>
  );
}
